import {
  ApiBlueprint,
  createFrontendModule,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import { CodeBuilderClient, codeBuilderApiRef } from './api';
import { codeBuilderFieldExtension } from './extensions/codeBuilderField';

// The read-only Dev Mode preview reuses `knowledgeApiRef` (registered by
// `knowledgeScaffolderModule`), but the interview itself talks to the
// code-builder backend, so this module contributes its own `codeBuilderApiRef`
// alongside the field extension.
const codeBuilderApiExtension = ApiBlueprint.make({
  name: 'code-builder',
  params: defineParams =>
    defineParams({
      api: codeBuilderApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new CodeBuilderClient({ discoveryApi, fetchApi }),
    }),
});

export const codeBuilderScaffolderModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [codeBuilderApiExtension, codeBuilderFieldExtension],
});
